/**
 * Photo pools for rotating images on marketing pages.
 * All images are from the approved children photos collection.
 * Hosted on Azure Blob Storage CDN for fast loading.
 *
 * Curated to ensure every photo shows the child's FACE clearly visible
 * when displayed in a landscape container with object-cover.
 * Criteria: face must be fully visible (eyes, nose, mouth), appropriate
 * for kindergarten marketing, and positioned in the upper portion of the frame.
 *
 * Removed photos where:
 * - Face is cropped/cut in landscape containers (full-body shots with tiny faces)
 * - Child is facing away or looking down
 * - Face is obscured by objects (fence, plants, pool edge)
 * - Expression is inappropriate for marketing (crying, very sad)
 * - Extreme close-ups showing only partial face
 */

const CDN_BASE = 'https://kipikidcdn.blob.core.windows.net/photos';

export const ALL_PHOTOS = [
  `${CDN_BASE}/aniq-danial-AGH_LXTM3Q0-unsplash.jpg`,
  `${CDN_BASE}/antonio-friedemann-LorcFaKYk34-unsplash.jpg`,
  `${CDN_BASE}/arto-suraj-lqKXG9vA0G8-unsplash.jpg`,
  `${CDN_BASE}/asit-kumar-ghatak-O87aXZfRglQ-unsplash.jpg`,
  `${CDN_BASE}/cristina-anne-costello-e7vD15H55x0-unsplash.jpg`,
  `${CDN_BASE}/devin-santiago-q1SdYpT0M_Q-unsplash.jpg`,
  `${CDN_BASE}/dottie-di-liddo-cYI6nwdR1a0-unsplash.jpg`,
  `${CDN_BASE}/dottie-di-liddo-KxQW6d9Hdds-unsplash.jpg`,
  `${CDN_BASE}/elizaveta-dushechkina-XPLCCRTX3ic-unsplash.jpg`,
  `${CDN_BASE}/eng-hs-O81w-NrC7T4-unsplash.jpg`,
  `${CDN_BASE}/francois-verbeeck-HLzKAhLr4Po-unsplash.jpg`,
  `${CDN_BASE}/hoi-an-and-da-nang-photographer-dSBo6B--1SA-unsplash.jpg`,
  `${CDN_BASE}/jackie-best--EZmsNyXbXo-unsplash.jpg`,
  `${CDN_BASE}/jackie-best-AXK5Geu0TFE-unsplash.jpg`,
  `${CDN_BASE}/janko-ferlic-LGlBwZGjiwM-unsplash.jpg`,
  `${CDN_BASE}/josephhershmedia-ZYBO7QZ2nms-unsplash.jpg`,
  `${CDN_BASE}/kyle-nieber--75ZH3qgFKg-unsplash.jpg`,
  `${CDN_BASE}/lukas-parnican-4mgtwMTVG6U-unsplash.jpg`,
  `${CDN_BASE}/lukas-parnican-j6GKug6Ybgk-unsplash.jpg`,
  `${CDN_BASE}/lukas-parnican-K4Vu-RPnMxc-unsplash.jpg`,
  `${CDN_BASE}/lukas-parnican-lMrzq3bDAlI-unsplash.jpg`,
  `${CDN_BASE}/lukas-parnican-zPakwmILhP4-unsplash.jpg`,
  `${CDN_BASE}/malik-naveed-photography-MVdFmjGG990-unsplash.jpg`,
  `${CDN_BASE}/mehdi-raad-JQlgvz5wTPY-unsplash.jpg`,
  `${CDN_BASE}/michael-walk-nW3W3fLWHY0-unsplash.jpg`,
  `${CDN_BASE}/peyman-farmani-S_C_3a0iApE-unsplash.jpg`,
  `${CDN_BASE}/r-d-smith-k-f3PYgAPwQ-unsplash.jpg`,
  `${CDN_BASE}/reynardo-etenia-wongso-dKU9u-a6uuQ-unsplash.jpg`,
  `${CDN_BASE}/shahin-khalaji-ywFhCe1u-ZA-unsplash.jpg`,
  `${CDN_BASE}/sylvester-sabo-SmXmGE6YqRs-unsplash.jpg`,
  `${CDN_BASE}/sylvester-sabo-Z-Lz8jHPKxI-unsplash.jpg`,
  `${CDN_BASE}/vikas-lone-Yz38N1-0XSo-unsplash.jpg`,
];
